<template>
    <v-card :class="{'px-3 py-4': $vuetify.breakpoint.smAndDown, 'pa-5': $vuetify.breakpoint.mdAndUp}" :width="$vuetify.breakpoint.lgAndUp ? 1134 : 'auto'">
        <v-form @submit.prevent="send_form(event)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('suggest_news_modal')">{{$t("закрыть")}}</v-icon>
            <v-card-title :class="{'mb-3 headline': $vuetify.breakpoint.smAndDown, 'mb-5 display-1': $vuetify.breakpoint.mdAndUp}">
                {{ event_only ? $t('Предложить мероприятие') : $t('Предложить новость/мероприятие') }}
            </v-card-title>
            <v-layout column>
                <v-layout row wrap>
                    <v-flex sm6 xs12
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Тип")}} *</div>
                        <v-select
                            v-model.trim="$v.type.$model"
                            solo
                            append-icon=""
                            class="input"
                            item-value="type"
                            :class="{ 'form-group--error': $v.type.$error }"
                            :items="translatedItems"
                            :label="$t('Новость/мероприятие')"
                            :disabled="event_only"
                            @change="if_event($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex sm6 xs12 :class="{'mt-4': $vuetify.breakpoint.xs}">
                        <div class="grey-text mb-2">{{$t("Название")}} *</div>
                        <inputBase :placeholder="$t('Введите название')"
                                   :class="{ 'form-group--error': $v.is_name.$error }" @change="event_name($event.target.value)"
                        />
                    </v-flex>
                </v-layout>
                <v-layout class="mt-4">
                    <v-flex xs12>
                        <div class="grey-text mb-2">{{$t("Описание")}}  *</div>
                        <textArea :placeholder="$t('Введите текст')" rows="4"
                                  :class="{ 'form-group--error': $v.descr.$error }"
                                  @change="event_text($event.target.value)"
                        ></textArea>
                    </v-flex>
                </v-layout>
                <v-layout v-if="is_event" wrap>
                    <v-flex md3 sm6 xs12
                            class="mt-4" :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Дата начала")}}</div>
                        <datepicker placeholder="01-01-2018" @input="event_date_from($event)" />
                    </v-flex>
                    <v-flex md3 sm6 xs12
                            class="mt-4" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Дата окончания")}}</div>
                        <datepicker placeholder="01-01-2018" @input="event_date_to($event)" />
                    </v-flex>
                    <v-flex md3 sm6 xs12
                            class="mt-4" :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Время начала")}}</div>
                        <inputBase type="time" :placeholder="$t('Введите время')" @change="event_time_from($event.target.value)" />
                    </v-flex>
                    <v-flex md3 sm6 xs12
                            class="mt-4"
                    >
                        <div class="grey-text mb-2">{{$t("Время окончания")}}</div>
                        <inputBase type="time" :placeholder="$t('Введите время')" @change="event_time_to($event.target.value)" />
                    </v-flex>
                    <v-flex sm6 xs12 class="mt-4"
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Формат")}} *</div>
                        <v-select
                            v-model.trim.lazy="format"
                            solo
                            append-icon=""
                            class="input"
                            :class="{ 'form-group--error': $v.format.$error }"
                            :items="event_types"
                            :label="$t('Выберите формат участия')"
                            @change="event_format($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex sm6 xs12 class="mt-4">
                        <div class="grey-text mb-2">{{$t("Адрес проведения")}}</div>
                        <inputBase :placeholder="$t('Введите адрес')" @change="event_address($event.target.value)" />
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md6 sm8 xs12
                            class="mt-4"
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Приложить файл")}}</div>
                        <inputUpload id="logo_upload" size="10000000" :placeholder="$t('Приложить файл') + '...'"
                                     :class="{ 'form-group--error': $v.file_size.$error }"
                                     @input.native="send_file($event)"
                                     @setFile="set_file_size"
                        />
                        <div class="grey-text mt-1">{{$t("Файл в формате jpg., jpeg., png. не более 10 МБ")}} </div>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-card-actions :class="{'mt-4': $vuetify.breakpoint.smAndDown, 'mt-5': $vuetify.breakpoint.mdAndUp}">
                <v-layout wrap align-center>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Отправить")}}</buttonRed>
                    <div class="grey-text">{{$t("* - поля, обязательные для заполнения")}}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>


<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {required, requiredIf, between} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import buttonRed from '@/components/ui/buttons/button_red';
import textArea from '@/components/ui/inputs/base/textarea.vue';
import inputBase from '@/components/ui/inputs/base/input';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import dayjs from 'dayjs';

export default {
  components: {
    buttonRed,
    inputBase,
    textArea,
    datepicker,
    inputUpload,
  },
  mixins     : [validationMixin],
  validations: {
    file_size: {
      between: between(0, 10000000),
    },
    type: {
      required,
    },
    is_name: {
      required,
    },
    descr: {
      required,
    },
    format: {
      required: requiredIf(function(model) {
        return this.is_event && model;
      }),
    },
  },
  props: {
    event_only: {
      type: Boolean,
    },
  },
  data() {
    return {
      file_size: '',
      is_event : false,
      type     : '',
      is_name  : '',
      descr    : '',
      format   : '',
      error    : false,
      event    : {
        'name'      : '',
        'text'      : '',
        'type'      : '',
        'date_start': '',
        'date_end'  : '',
        'time_start': '',
        'time_end'  : '',
        'format'    : '',
        'address'   : '',
        'files'     : [
          '',
        ],
      },
      date: [],
    };
  },
  computed: {
    ...mapGetters('news_main', ['event_types']),
    ...mapGetters('news_offer', ['current_item', 'items']),
    translatedItems() {
      return this.items.map((item) => ({
        ...item,
        text: this.$t(item.text),
      }));
    }
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  mounted() {
    if (this.event_only) {
      this.is_event = true;
      this.event.type = 'event';
      this.$v.type.$model = 'Мероприятие';
    }
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('news_main', ['CLOSE_MODAL']),
    ...mapActions('news_main', ['send_suggestion']),

    set_file_size($event) {
      this.file_size = $event;
      this.$v.file_size.$touch();
    },
    send_file($event) {
      let files = $event.target.files;
      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.event.files[0] = reader.result;
      };
    },
    if_event($event) {
      // this.event.label = $event;
      this.$v.type.$touch();
      if ($event == 'Мероприятие') {
        this.is_event = true;
        this.event.type = 'event';
      } else {
        this.is_event = false;
        this.event.type = 'news';
      }
    },
    event_address(ev) {
      this.event.address = ev;
    },
    event_name(ev) {
      this.is_name = ev;
      this.event.name = ev;
      this.$v.is_name.$touch();
    },
    event_text(ev) {
      this.descr = ev;
      this.event.text = ev;
      this.$v.descr.$touch();
    },
    event_format(ev) {
      this.event.format = ev;
      this.$v.format.$touch();
    },
    event_date_from(ev) {
      this.event.date_start = ev.target.defaultValue.slice(0, 10);
      this.date[0] = ev.target.defaultValue.slice(0, 10);
    },
    event_date_to(ev) {
      this.event.date_end = ev.target.defaultValue.slice(0, 10);
      this.date[1] = ev.target.defaultValue.slice(0, 10);
    },
    event_time_from(ev) {
      this.event.time_start = ev;
    },
    event_time_to(ev) {
      this.event.time_end = ev;
    },

    send_form(event) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error = true;
      } else {
        this.error = false;
        this.CLOSE_MODAL('suggest_news_modal');
        this.send_suggestion(event);
      }
    },
  },
};
</script>
